export default __webpack_public_path__ + "static/media/24.2a8d5698.png";